import React from 'react';

function Email(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M19.5 5.3335H4.5C3.92353 5.3335 3.40764 5.59394 3.06363 6.00353C3.0545 6.01391 3.04564 6.02466 3.03709 6.03578C3.03671 6.03629 3.03632 6.03679 3.03594 6.03729C2.77882 6.35823 2.625 6.76547 2.625 7.2085V17.2085C2.625 18.2437 3.46482 19.0835 4.5 19.0835H19.5C20.5352 19.0835 21.375 18.2437 21.375 17.2085V7.2085C21.375 6.76547 21.2212 6.35823 20.9641 6.03729C20.9637 6.03679 20.9633 6.03628 20.9629 6.03578C20.9544 6.02466 20.9455 6.01391 20.9364 6.00353C20.5924 5.59394 20.0765 5.3335 19.5 5.3335ZM19.2257 6.5835H4.77433L10.7003 11.1415C11.4186 11.6943 12.4013 11.7288 13.1527 11.2451L13.2998 11.1414L19.2257 6.5835ZM3.875 7.46876V17.2085C3.875 17.5533 4.15518 17.8335 4.5 17.8335H19.5C19.8448 17.8335 20.125 17.5533 20.125 17.2085V7.46876L14.062 12.1321C12.9017 13.025 11.3064 13.0656 10.1067 12.254L9.93812 12.1322L3.875 7.46876Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Email;
